import { useAuthSubscribe } from '@ankr.com/auth';
import { EWalletId } from '@ankr.com/provider';

import {
  setAuthAddress,
  setAuthProvider,
  setAuthToken,
  setAuthTokenExpiresAt,
  setIsMarketingAccepted,
  setIsSignedIn,
  setReferralCode,
  setWalletId,
} from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';

export const useAuthDataSubscriber = () => {
  const dispatch = useAppDispatch();

  useAuthSubscribe(data => {
    dispatch(setAuthAddress(data.authAddress));
    dispatch(setAuthProvider(data.provider));
    dispatch(setAuthToken(data.accessToken));
    dispatch(setAuthTokenExpiresAt(data.expiresAt));
    dispatch(setIsSignedIn(data.isSignedIn));
    dispatch(setReferralCode(data.referralCode));
    dispatch(setWalletId(data.walletId as EWalletId | undefined));
    if (data.isMarketingAccepted) {
      dispatch(setIsMarketingAccepted(data.isMarketingAccepted === 'true'));
    } else {
      dispatch(setIsMarketingAccepted(undefined));
    }
  });
};
